module.exports = __webpack_public_path__ + "static/media/stars.438aefda.svg";